// extracted by mini-css-extract-plugin
module.exports = {"wrapper_div":"styles__wrapper_div--1d59N"};